import styled from '@emotion/styled'

export const TopInfo = styled.div`
`

export const TopInfoItem = styled.div`
  display: grid;
  grid-template-columns: 130px auto;
  div:nth-of-type(2) {
    &::before {
      content: ': ';
    }
  }
`
